import { $ } from './modules/dom.ts';

($('#copy-image') as HTMLElement).onclick = () => {
  navigator.clipboard.writeText(`![Graphic](${($('div.graphic img') as HTMLImageElement).src})`);
};

($('#open-resizable') as HTMLElement).onclick = () => {
  const { width, height } = $('div.graphic img') as HTMLImageElement;
  open('/frames/server-resizable/', '_blank', `popup=true,width=${width},height=${height}`);
};
